import { useEffect } from "react";
import moment from "moment";
import "moment/locale/es";
import { Box, Chip, Tooltip, Typography } from "@mui/material";

import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import TodayIcon from "@mui/icons-material/Today";

moment.locale("es");

const DateSelector = ({ selectedDate, onDateChange }) => {
  const today = moment().format("YYYY-MM-DD");
  const minDate = moment().subtract(30, "days").format("YYYY-MM-DD");
  const maxDate = moment().add(1, "days").format("YYYY-MM-DD");
  const isToday = selectedDate === today;

  useEffect(() => {
    if (selectedDate < minDate) {
      onDateChange(minDate);
    } else if (selectedDate > maxDate) {
      onDateChange(maxDate);
    }
  }, [selectedDate, minDate, maxDate, onDateChange]);


  const handleToday = () => {
    onDateChange(today);
  };

  return (
    <Box
      sx={{
        mb: 2,
        borderRadius: "14px",
        background:
          "linear-gradient(135deg, #1a237e 0%, #283593 60%, #3949ab 100%)",
        boxShadow: "0 4px 20px rgba(26,35,126,0.35)",
        p: "10px 14px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "6px",
        flexWrap: "wrap",
        position: "relative",
        overflow: "hidden",
        "&::before": {
          content: '""',
          position: "absolute",
          top: "-30px",
          right: "-30px",
          width: "100px",
          height: "100px",
          borderRadius: "50%",
          background: "rgba(255,255,255,0.04)",
          pointerEvents: "none",
        },
      }}
    >
      <CalendarTodayIcon
        sx={{ color: "rgba(255,255,255,0.75)", fontSize: 16 }}
      />

      <Typography
        variant="caption"
        sx={{
          color: "rgba(255,255,255,0.7)",
          fontWeight: 700,
          letterSpacing: "0.07em",
          textTransform: "uppercase",
          fontSize: "9.5px",
          mr: "2px",
        }}
      >
        Indique la fecha
      </Typography>


      <Box
        component="input"
        type="date"
        value={selectedDate}
        onChange={(e) => onDateChange(e.target.value)}
        min={minDate}
        max={maxDate}
        sx={{
          border: "1px solid rgba(255,255,255,0.28)",
          borderRadius: "8px",
          backgroundColor: "rgba(255,255,255,0.12)",
          backdropFilter: "blur(8px)",
          color: "#ffffff",
          fontSize: "13px",
          fontWeight: 600,
          padding: "5px 10px",
          outline: "none",
          cursor: "pointer",
          fontFamily: "inherit",
          letterSpacing: "0.03em",
          transition: "all 0.2s",
          colorScheme: "dark",
          "&:hover": {
            backgroundColor: "rgba(255,255,255,0.2)",
            borderColor: "rgba(255,255,255,0.5)",
          },
          "&:focus": {
            backgroundColor: "rgba(255,255,255,0.22)",
            borderColor: "rgba(255,255,255,0.7)",
            boxShadow: "0 0 0 2px rgba(255,255,255,0.15)",
          },
          "&::-webkit-calendar-picker-indicator": {
            filter: "invert(1) opacity(0.7)",
            cursor: "pointer",
          },
        }}
      />

      {!isToday && (
        <Tooltip title="Volver a hoy">
          <Chip
            icon={
              <TodayIcon
                sx={{ fontSize: "13px !important", color: "#fff !important" }}
              />
            }
            label="Hoy"
            size="small"
            onClick={handleToday}
            sx={{
              height: "24px",
              fontSize: "11px",
              fontWeight: 700,
              backgroundColor: "rgba(255,255,255,0.15)",
              color: "#fff",
              border: "1px solid rgba(255,255,255,0.35)",
              cursor: "pointer",
              backdropFilter: "blur(4px)",
              transition: "all 0.2s",
              "& .MuiChip-label": { px: "8px" },
              "&:hover": {
                backgroundColor: "rgba(255,255,255,0.28)",
                transform: "scale(1.04)",
              },
            }}
          />
        </Tooltip>
      )}

    </Box>
  );
};

export default DateSelector;